module.exports = __webpack_public_path__ + "eb04c64efb13ed9f8d90930b0e19e5d0.svg";